import React from "react";
import PropTypes from "prop-types";

class TabContent extends React.Component {
  componentDidMount() {
    const { group, isActive } = this.props;
    this.props.registerTabsGroup(group);
    if (this.tabContent) {
      if (isActive && !this.tabContent.classList.contains("show")) {
        this.tabContent.classList.add("show");
      } else if (!isActive && this.tabContent.classList.contains("show")) {
        this.tabContent.classList.remove("show");
      }
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.isActive !== this.props.isActive) {
      this.onToggle(props.isActive);
    }
  }

  onToggle(active) {
    const { transitionDuration } = this.props;

    if (this.props.animate && this.tabContent !== null) {
      if (active) {
        setTimeout(() => {
          if (this.tabContent) {
            this.tabContent.classList.add("show");
            this.props.onActivated();
          }
        }, transitionDuration);
      } else if (this.tabContent?.classList.contains("show")) {
        this.tabContent.classList.add("active");
        this.tabContent.classList.remove("show");
        setTimeout(() => {
          this.tabContent?.classList.remove("active");
        }, transitionDuration);
      }
    }
  }

  render() {
    const { children, className, animate, transitionDuration, name, isActive } =
      this.props;
    const classNames = ["Tabs__Content", className];
    if (isActive) {
      classNames.push("active");
    }
    if (animate) {
      classNames.push("animate");
    }
    return (
      <div
        ref={(domNode) => {
          this.tabContent = domNode;
        }}
        data-tab={name}
        className={classNames.join(" ")}
        style={{ transitionDuration: `${transitionDuration}ms` }}
      >
        {children}
      </div>
    );
  }
}

TabContent.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  transitionDuration: PropTypes.number,
  animate: PropTypes.bool,
  onActivated: PropTypes.func,
  group: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  registerTabsGroup: PropTypes.func,
};

TabContent.defaultProps = {
  transitionDuration: 300,
  animate: true,
  className: "",
  onActivated: () => null,
  isActive: false,
  registerTabsGroup: () => null,
};

export default TabContent;
